<p-dialog [modal]="true" [(visible)]="visible">
    <ng-template pTemplate="header">
        <span class="p-dialog-title">
            Add Forecast detail for {{ forecast.planningParameter.name }}
        </span>
    </ng-template>

    <p-fluid>
        <div class="field">
            <label for="subsidiary">Legal entity</label>
            <p-select
                id="subsidiary"
                placeholder="Select a legal entity"
                [options]="(subsidiaries$ | async)?.getSubsidiaries()"
                optionLabel="name"
                appendTo="body"
                [(ngModel)]="selectedSubsidiary"
            ></p-select>
        </div>
        <div class="field">
            <label for="quantity">Container quantity</label>
            <p-inputNumber
                id="quantity"
                showButtons="true"
                [(ngModel)]="forecastDetailQuantity"
            />
        </div>
    </p-fluid>

    <ng-template #footer>
        <p-button label="Cancel" [text]="true" severity="secondary" (click)="closeModal()"/>
        <p-button label="Save" [outlined]="true" severity="success" (click)="saveNewForecastDetail()" />
    </ng-template>
</p-dialog>
